<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новая функция',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
		return {
			title: 'Новая функция',
			items: [],
            trackBy: 'id',
            action_uuid: '',
            name: '',
            code: '',
            product: null,
            initProduct: [],
            products_options: [],
		}
	},

    watch: {
        initProduct: {
            immediate: true,
            handler(values) {
                this.product = this.products_options.filter(x => values.includes(x[this.trackBy]));
                this.product = this.product[0];
            }
        }
    },

	computed: {
        action_item(){
            return this.$store.getters['actions/GET_ACTIONS_ITEM'];
        },
        products_list_data(){
            return this.$store.getters['products/GET_PRODUCTS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

	    this.action_uuid = this.$route.params.action_uuid ? this.$route.params.action_uuid : '';

        await this.$store.dispatch('products/FETCH_PRODUCTS_LIST', {});
        this.products_options = this.products_list_data;

	    if(this.action_uuid !== ''){

            this.title = 'Редактирование функции';
            document.title = appConfig.title + ' - ' + 'Редактирование функции';

            let data_send = {
                'uuid' : this.action_uuid
            }

            await this.$store.dispatch('actions/FETCH_ACTIONS_ITEM', data_send);

            this.name = this.action_item.name ? this.action_item.name : '';
            this.code = this.action_item.code ? this.action_item.code : '';
            this.product = this.action_item.product_id ? this.action_item.product_id : '';
            if (this.product !== null) {
                this.initProduct = [this.product];
            }
        }
	},

	methods: {

        async saveItem(){

            let data_send = {
                'name' : this.name,
                'code' : this.code,
                'product_id' : this.product && this.product.id ? this.product.id : null,
            };

            let result = '';

            if(this.action_uuid === ''){
                result = await this.$store.dispatch('actions/FETCH_ACTIONS_CREATE', data_send);
            } else {
                data_send.uuid = this.action_uuid;
                result = await this.$store.dispatch('actions/FETCH_ACTIONS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Actions'});
            }
        }
	},
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Название функции"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название функции"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder="Укажите код функции"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Услуга"
                                        label-for="product"
                                    >
                                        <multiselect
                                            id="product"
                                            :track-by="trackBy"
                                            v-model="product"
                                            :options="products_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
